import apiClient from './client.js';

/**
 * Upload a file to the CRM server.
 * @param {File} file
 * @param {{ purpose?: 'email-asset' }} [opts] — 'email-asset' marks the file public at
 *   upload (server enforces image/* — C3-A16 spec §4.3); omit for private-until-sent.
 * @returns {Promise<{ url: string, filename: string, originalName: string, size: number, mimeType: string }>}
 */
export async function uploadFile(file, { purpose } = {}) {
  const formData = new FormData();
  if (purpose) formData.append('purpose', purpose);
  formData.append('file', file);
  const { data } = await apiClient.post('/uploads', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return data;
}
